/**
 * NativeWaves Org API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class TeamsApi extends runtime.BaseAPI {
    /**
     * Get a paginated list of teams.
     */
    async teamsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null ||
            requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling teamsGet.');
        }
        const queryParameters = {};
        if (requestParameters.organizationId !== undefined) {
            queryParameters['organizationId'] = requestParameters.organizationId;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of teams.
     */
    async teamsGet(requestParameters, initOverrides) {
        const response = await this.teamsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new team.
     */
    async teamsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.orgTeamInsert === null ||
            requestParameters.orgTeamInsert === undefined) {
            throw new runtime.RequiredError('orgTeamInsert', 'Required parameter requestParameters.orgTeamInsert was null or undefined when calling teamsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgTeamInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new team.
     */
    async teamsPost(requestParameters, initOverrides) {
        const response = await this.teamsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a team.
     */
    async teamsTeamIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}`.replace(`{${'teamId'}}`, String(requestParameters.teamId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a team.
     */
    async teamsTeamIdDelete(requestParameters, initOverrides) {
        await this.teamsTeamIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a team.
     */
    async teamsTeamIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}`.replace(`{${'teamId'}}`, String(requestParameters.teamId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a team.
     */
    async teamsTeamIdGet(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of invitations.
     */
    async teamsTeamIdInvitationsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdInvitationsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/invitations`.replace(`{${'teamId'}}`, String(requestParameters.teamId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of invitations.
     */
    async teamsTeamIdInvitationsGet(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdInvitationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an invitation.
     */
    async teamsTeamIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdInvitationsInvitationIdDelete.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling teamsTeamIdInvitationsInvitationIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/invitations/{invitationId}`
                .replace(`{${'teamId'}}`, String(requestParameters.teamId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an invitation.
     */
    async teamsTeamIdInvitationsInvitationIdDelete(requestParameters, initOverrides) {
        await this.teamsTeamIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an invitation.
     */
    async teamsTeamIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdInvitationsInvitationIdGet.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling teamsTeamIdInvitationsInvitationIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/invitations/{invitationId}`
                .replace(`{${'teamId'}}`, String(requestParameters.teamId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an invitation.
     */
    async teamsTeamIdInvitationsInvitationIdGet(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an invitation.
     */
    async teamsTeamIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling teamsTeamIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.orgTeamRoleRamInvitationEdit === null ||
            requestParameters.orgTeamRoleRamInvitationEdit === undefined) {
            throw new runtime.RequiredError('orgTeamRoleRamInvitationEdit', 'Required parameter requestParameters.orgTeamRoleRamInvitationEdit was null or undefined when calling teamsTeamIdInvitationsInvitationIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/invitations/{invitationId}`
                .replace(`{${'teamId'}}`, String(requestParameters.teamId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgTeamRoleRamInvitationEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an invitation.
     */
    async teamsTeamIdInvitationsInvitationIdPatch(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new invitation.
     */
    async teamsTeamIdInvitationsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdInvitationsPost.');
        }
        if (requestParameters.orgTeamRoleRamInvitationInsert === null ||
            requestParameters.orgTeamRoleRamInvitationInsert === undefined) {
            throw new runtime.RequiredError('orgTeamRoleRamInvitationInsert', 'Required parameter requestParameters.orgTeamRoleRamInvitationInsert was null or undefined when calling teamsTeamIdInvitationsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/invitations`.replace(`{${'teamId'}}`, String(requestParameters.teamId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgTeamRoleRamInvitationInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new invitation.
     */
    async teamsTeamIdInvitationsPost(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdInvitationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of members.
     */
    async teamsTeamIdMembersGetRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdMembersGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling teamsTeamIdMembersGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/members`.replace(`{${'teamId'}}`, String(requestParameters.teamId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of members.
     */
    async teamsTeamIdMembersGet(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdMembersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a team member.
     */
    async teamsTeamIdMembersMemberIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdMembersMemberIdDelete.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling teamsTeamIdMembersMemberIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/members/{memberId}`
                .replace(`{${'teamId'}}`, String(requestParameters.teamId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a team member.
     */
    async teamsTeamIdMembersMemberIdDelete(requestParameters, initOverrides) {
        await this.teamsTeamIdMembersMemberIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a team member.
     */
    async teamsTeamIdMembersMemberIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdMembersMemberIdGet.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling teamsTeamIdMembersMemberIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/members/{memberId}`
                .replace(`{${'teamId'}}`, String(requestParameters.teamId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a team member.
     */
    async teamsTeamIdMembersMemberIdGet(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdMembersMemberIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a team member.
     */
    async teamsTeamIdMembersMemberIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdMembersMemberIdPatch.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling teamsTeamIdMembersMemberIdPatch.');
        }
        if (requestParameters.orgTeamRoleRamMemberEdit === null ||
            requestParameters.orgTeamRoleRamMemberEdit === undefined) {
            throw new runtime.RequiredError('orgTeamRoleRamMemberEdit', 'Required parameter requestParameters.orgTeamRoleRamMemberEdit was null or undefined when calling teamsTeamIdMembersMemberIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/members/{memberId}`
                .replace(`{${'teamId'}}`, String(requestParameters.teamId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgTeamRoleRamMemberEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a team member.
     */
    async teamsTeamIdMembersMemberIdPatch(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdMembersMemberIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new team member.
     */
    async teamsTeamIdMembersPostRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdMembersPost.');
        }
        if (requestParameters.orgTeamRoleRamMemberInsert === null ||
            requestParameters.orgTeamRoleRamMemberInsert === undefined) {
            throw new runtime.RequiredError('orgTeamRoleRamMemberInsert', 'Required parameter requestParameters.orgTeamRoleRamMemberInsert was null or undefined when calling teamsTeamIdMembersPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}/members`.replace(`{${'teamId'}}`, String(requestParameters.teamId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgTeamRoleRamMemberInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new team member.
     */
    async teamsTeamIdMembersPost(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdMembersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a team.
     */
    async teamsTeamIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.teamId === null ||
            requestParameters.teamId === undefined) {
            throw new runtime.RequiredError('teamId', 'Required parameter requestParameters.teamId was null or undefined when calling teamsTeamIdPatch.');
        }
        if (requestParameters.orgTeamEdit === null ||
            requestParameters.orgTeamEdit === undefined) {
            throw new runtime.RequiredError('orgTeamEdit', 'Required parameter requestParameters.orgTeamEdit was null or undefined when calling teamsTeamIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/teams/{teamId}`.replace(`{${'teamId'}}`, String(requestParameters.teamId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orgTeamEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a team.
     */
    async teamsTeamIdPatch(requestParameters, initOverrides) {
        const response = await this.teamsTeamIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const TeamsTeamIdMembersGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
//# sourceMappingURL=TeamsApi.js.map